module.exports = __webpack_public_path__ + "img/A相截取.dedae173.png";